import React, { useContext } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import { useSelector } from "react-redux";
import { formatDate } from "../../../JsHelpers/DateFormat";
import PlayBackTripHead from "../HistoryPlayBackTrip/HistoryPlayBackTripHead/PlayBackTripHead";
import PlayBackSpeed from "./PlayBackSpeed";
import PlayBackParameters from "./PlayBackParameters";
import ObjectMinimized from "../../LiveTracking/Object/ObjectMinimized/ObjectMinimized";

export default function PlayBackControls({
	maxValue,
	setPlayAllHist,
	setPlayBackSpeed,
	minimzeMediaPlayer,
	setMedia,
	setMinimizeMediaPlayer,
}) {
	let { isPlaying, setIsPlaying, posIndex, setPosIndex } =
		useContext(popupcontext);
	//let [currentIndex, setCurrentIndex] = useState(0);
	const data = useSelector((state) => state.webSocket.historypositions);
	const { formattedDate, formattedTime } = formatDate(
		data[posIndex]?.deviceTime,
	);
	const moveNext = () => {
		if (posIndex + 1 !== data?.length) setPosIndex(Number(posIndex) + 1);
	};
	const moveBack = () => {
		if (posIndex !== 0) setPosIndex(Number(posIndex) - 1);
	};
	const moveFirstPoint = () => {
		setPosIndex(0);
	};
	const moveLastPoint = () => {
		setPosIndex(data?.length - 1);
	};
	const lang = localStorage.getItem("lang") || "en";
	return (
		<>
			{!minimzeMediaPlayer ? (
				<div
					className={`history-playback-media ${
						lang === "ar"
							? "history-playback-media-rtl"
							: "history-playback-media-ltr"
					}`}
				>
					<PlayBackTripHead
						type="hist-player"
						setPlayAllHist={setPlayAllHist}
						setIsPlaying={setIsPlaying}
						setMinimizeMediaPlayer={setMinimizeMediaPlayer}
						minimzeMediaPlayer={minimzeMediaPlayer}
						setMedia={setMedia}
					/>
					<div className="H-line"></div>
					<div className="p-3">
						<input
							type="range"
							min="0"
							max={data?.length - 1}
							value={posIndex}
							onChange={(e) => {
								setPosIndex(Number(e.target.value));
							}}
							className="history-playback-slider"
							dir={lang === "ar" ? "rtl" : "ltr"}
						/>
						<div className="history-playback-current data">
							<div className="flex-between fs-14">
								<div>
									{Number(posIndex) + 1}/{data?.length}
								</div>
								<div>{formattedDate + " " + formattedTime}</div>
							</div>
						</div>
						<div className="flex-between">
							<div className="history-playback-mediaplayer w-50">
								<div className="mediabutton">
									<img
										src={`${process.env.PUBLIC_URL}/assets/doubleback.svg`}
										style={{ transform: lang === "ar" && "rotate(180deg)" }}
										alt="media"
										onClick={moveFirstPoint}
									/>
								</div>
								<div className="mediabutton">
									<img
										src={`${process.env.PUBLIC_URL}/assets/SingleBack.svg`}
										style={{ transform: lang === "ar" && "rotate(180deg)" }}
										alt="media"
										onClick={moveBack}
									/>
								</div>
								<div className="mediabutton">
									<img
										src={
											isPlaying
												? `${process.env.PUBLIC_URL}/assets/Pause.svg`
												: `${process.env.PUBLIC_URL}/assets/Play.svg`
										}
										alt="media"
										onClick={() => setIsPlaying(!isPlaying)}
									/>
								</div>
								<div className="mediabutton">
									<img
										src={`${process.env.PUBLIC_URL}/assets/SingleNext.svg`}
										style={{ transform: lang === "ar" && "rotate(180deg)" }}
										alt="media"
										onClick={moveNext}
									/>
								</div>
								<div className="mediabutton">
									<img
										src={`${process.env.PUBLIC_URL}/assets/doublenext.svg`}
										style={{ transform: lang === "ar" && "rotate(180deg)" }}
										alt="media"
										onClick={moveLastPoint}
									/>
								</div>
							</div>
							<PlayBackSpeed setPlayBackSpeed={setPlayBackSpeed} />
							<PlayBackParameters parameters={data} />
						</div>
					</div>
				</div>
			) : (
				<ObjectMinimized
					name="Media"
					minimize={() => {
						setMinimizeMediaPlayer(false);
						setMedia(true);
					}}
				/>
			)}
		</>
	);
}
